import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getAuth, setPersistence, browserLocalPersistence } from 'firebase/auth';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics, isSupported } from 'firebase/analytics';

// Firebase configuration
const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY || process.env.FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || process.env.FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || process.env.FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || process.env.FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || process.env.FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID || process.env.FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || process.env.FIREBASE_MEASUREMENT_ID,
};

// Validate BEFORE initialization
const required = ['apiKey', 'authDomain', 'projectId'];
const missing = required.filter(key => 
    !firebaseConfig[key] || 
    firebaseConfig[key] === 'your_api_key_here' || 
    firebaseConfig[key] === 'your_project_id' || 
    firebaseConfig[key].includes('your_')
);

if (missing.length > 0) {
    throw new Error(`Missing or placeholder Firebase configuration for: ${missing.join(', ')}. Please check your .env file and ensure you've added your Firebase project configuration from https://console.firebase.google.com`);
}

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
setPersistence(auth, browserLocalPersistence).catch(console.error);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Analytics — only available in browser environments that support it (not SSR / bots)
let analyticsInstance = null;
isSupported().then(yes => {
    if (yes && firebaseConfig.measurementId) {
        analyticsInstance = getAnalytics(app);
    }
}).catch(() => {});
export const getAnalyticsInstance = () => analyticsInstance;

export default app;